// extracted by mini-css-extract-plugin
export var notice = "showcaseNotice-module--notice--egFSy";
export var dot = "showcaseNotice-module--dot--FnUpO";
export var long = "showcaseNotice-module--long--slXqy";